module.exports = __webpack_public_path__ + "da78a58274c27426c34d816d5f5aae74.png";